export default __webpack_public_path__ + "static/media/minifi.8af1e6ec.png";